import { render } from "./VisualNavigation.vue?vue&type=template&id=70c30052&scoped=true"
import script from "./VisualNavigation.vue?vue&type=script&lang=js"
export * from "./VisualNavigation.vue?vue&type=script&lang=js"

import "./VisualNavigation.vue?vue&type=style&index=0&id=70c30052&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c30052"]])

export default __exports__